export default __webpack_public_path__ + "static/media/General_scroll.6e2d5e87.png";